module.exports = __webpack_public_path__ + "assets/icon-message.561b4d41.svg";